// Same origin as the app itself — Front Door path-routes /api/* on this
// domain to the Function App, everything else to the Static Web App.
const publicDomain = 'https://bare-reporting-dev.stenametall.cloud';

export const environment = {
  production: false,
  apiBaseUrl: publicDomain,
  contact: {
    name: 'Alice Törnqvist',
    email: 'alice.a.tornqvist@stenarecycling.com',
  },
  auth: {
    clientId: '7845849d-219c-4440-836a-8fd69789b71d',
    tenantId: '7920093a-3a65-4aba-8d54-76b28484a094',
    redirectUri: publicDomain,
    postLogoutRedirectUri: publicDomain,
    scopes: [
      'openid',
      'profile',
      'offline_access',
      'api://7845849d-219c-4440-836a-8fd69789b71d/General',
    ],
  },
};
